import AuthCallback from "./auth-callback";
export default AuthCallback;
